import './DoctorFull.css';
import ModalContext from '../MakeAppointmentModal/ModalProvider';
import React, { useContext } from 'react';
import { checkRU } from '../../index';

const DoctorFull = ({ doctor }) => {
    const { isRu, apiUrl } = checkRU();
    const { modalOn, modalData } = useContext(ModalContext);

    const BUTTON_TEXT = isRu ? "ЗАПИСАТЬСЯ НА КОНСУЛЬТАЦИЮ" : "ЗАПИСАТИСЯ НА КОНСУЛЬТАЦІЮ";
    
    const onClick = () => {
        isRu ? modalData("Консультация - " + doctor.name, BUTTON_TEXT) : modalData("Консультація - "+doctor.name, BUTTON_TEXT);
        modalOn();
    };

    return (
        <div className="doctor-container-full hoverable">
            <div className="doctor-presentation-div">
                <img src={doctor.image} className="doctor-image" />
                <h2>{doctor.name}</h2>
                <div className="doctor-field">{doctor.field}</div>
            </div>
            <div className="doctor-data">
                <h4 className="doctor-data-h">{isRu ? "Специализация" : "Спеціалізація"}</h4>
                <div>{doctor.specialization}</div>
                <h4 className="doctor-data-h">{isRu ? "Опыт медицинской практики" : "Досвід медичної практики"}</h4>
                <div>{doctor.experience}</div>
                <h4 className="doctor-data-h">{isRu ? "Образование" : "Освіта"}</h4>
                <div>{doctor.education}</div>
            </div>
            <div className="doctor-button-div display-on-hover"><button className="doctor-button" onClick={onClick}><h2 className="h2-button borderless">{BUTTON_TEXT}</h2></button></div>
        </div>
    );
}

export default DoctorFull;